import localStorage from "../../../js/localStorage";

/**
 * For using concrete jivo widget id you must specify on top of your website
 * js variables window.JIVO_WIDGET_ID = 'some widget id'
 */

// the name of the variable - show is jivo site was enabled
const JIVO_PUSHED = "JIVO_PUSHED";

const DEFAULT_JIVO_WIDGET_ID = "O4n303t222";

/**
 * Dinamically add jivosite script to page
 */
function addScript() {
    $(".jivo-button").hide("fast");

    (function () {
        var widget_id = window.JIVO_WIDGET_ID || DEFAULT_JIVO_WIDGET_ID;
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "//code.jivosite.com/script/widget/" + widget_id;
        var ss = document.getElementsByTagName("script")[0];
        ss.parentNode.insertBefore(s, ss);
    })();
}

function initJivoOpenOnLoad() {
    window.jivo_onLoadCallback = () => {
        jivo_api.open();
    };
}

window.jivo_onMessageSent = () => {
    console.log("первое");
    window.localStorage.setItem("jivoFirstMsg", "true");
};

/**
 * Initialize page script for jivosite
 * Если хотябы один раз пользователь активировал jivosite, то он будет прогружаться для каждой страницы
 */
export function initJivo() {
    // ХЗ ДЛЯ ЧЕГО, поэтому закоментил
    // if (typeof window['renderJivo'] !== 'undefined' && window['renderJivo'] === false) {
    //     return;
    // }

    if (localStorage.get(JIVO_PUSHED)) {
        addScript();
        setTimeout(() => {
            jivo_api.open();
        }, 60000);
    } else {
        setTimeout(() => {
            addScript();
            initJivoOpenOnLoad();
        }, 60000);
    }
}

// запускается каждыве 5 мин, если не было отправлено ни 1 сообщения
// если че просто переменную можно закинуть и сделать лимит в иф
const regularJivo = () => {
    if (localStorage.get("jivoFirstMsg")) {
        return;
    }

    setTimeout(() => {
        jivo_api.open();
        regularJivo();
    }, 300000);
};

window.activateJivoChat = function () {
    // установка калбэка после загрузки при загрузке скрипта и нажатии на кнопке, мы должны развернуть окно
    initJivoOpenOnLoad();

    // добавим скрипт
    addScript();

    // при новой загрузке страницы, мы будем подгружать живо автоматически
    localStorage.set(JIVO_PUSHED, true);
};

// document load event handler
if (window.innerWidth > 1024) {
    $(initJivo);
}

// $(regularJivo);
